import { Client } from "@be/client";
import { authenticatedFetch } from "./fetch-utils";

export const apiClient = Client(import.meta.env.VITE_API_URL, {
	fetch: authenticatedFetch,
}).api;
